import React from 'react';
import { GatsbyImage, StaticImage, getImage, withArtDirection } from 'gatsby-plugin-image';
import ChargeFee from 'assets/icons/ic_charge_fee.inline.svg';
import HandMoney from 'assets/icons/ic_hand_money.inline.svg';
import Support from 'assets/icons/ic_support.inline.svg';
import Title from './Title';

import './hero.scss';

const Hero = ({ heroDesktop, heroMobile, heroTablet, hideDataphones }) => {
  const images = withArtDirection(getImage(heroMobile), [
    {
      media: '(min-width: 1280px)',
      image: getImage(heroDesktop),
    },
  ]);

  return (
    <section id="home-hero" className="home-hero">
      <div className="section-container">
        <Title />
        <div className="home-hero-image">
          <GatsbyImage image={images} alt="Bold" className="art-directed" loading="eager" fetchpriority="high" />
          <div className="show-tablet">
            <GatsbyImage image={getImage(heroTablet)} alt="Bold" loading="eager" fetchpriority="high" />
          </div>
          {!hideDataphones && (
            <>
              <div className="show-mobile-flex">
                <StaticImage className="front-mpos" src="./images/front-sm.png" alt="Bold Home Hero" loading="eager" />
              </div>
              <div className="show-tablet-flex">
                <StaticImage className="front-mpos" src="./images/front-md.png" alt="Bold Home Hero" loading="eager" />
              </div>
              <div className="show-desktop-flex">
                <StaticImage className="front-mpos" src="./images/front-xl.png" alt="Bold Home Hero" loading="eager" />
              </div>
            </>
          )}
        </div>

        <div className="home-hero-benefits">
          <div className="section-grid">
            <div className="grid-item">
              <div className="svg-wrapper">
                <ChargeFee />
              </div>

              <p>No pagas alquileres ni mensualidades</p>
            </div>
            <div className="grid-item">
              <div className="svg-wrapper">
                <HandMoney />
              </div>
              <p>Recibes tu dinero todos los días hábiles</p>
            </div>
            <div className="grid-item">
              <div className="svg-wrapper">
                <Support />
              </div>
              <p>Tienes acceso a soporte 24/7</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
